var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-3" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("p", [_vm._v(_vm._s(_vm.interval))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.maxMessages))]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-3" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("p", [_vm._v(_vm._s(_vm.createdAt))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.updatedAt))]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-3" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("p", [_vm._v(_vm._s(_vm.totalMessageCount))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.createdMessageCount))]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-6" }, [
      _c("p", { staticClass: "el-style attribute-name" }, [
        _vm._v("Minimum interval:"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [
        _vm._v("Messages limit:"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-6" }, [
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Created:")]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [_vm._v("Updated:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-6" }, [
      _c("p", { staticClass: "el-style attribute-name" }, [
        _vm._v("Messages total:"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "el-style attribute-name" }, [
        _vm._v("Messages sent:"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }